import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ProfileCategory, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const sellerProfilesCategoriesAdapter = createEntityAdapter<JSONApiDataObject<ProfileCategory>>({
  selectId: item => item.id
});

export const sellerProfilesCategoriesSlice = createSlice({
  name: 'sellerProfilesCategories',
  initialState: sellerProfilesCategoriesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<ProfileCategory>>),
  reducers: {
    sellerProfilesCategoriesAdded: (state, action) => {
      sellerProfilesCategoriesAdapter.setMany(state, action.payload);
    }
  }
});

export const sellerProfilesCategoriesSelectors = sellerProfilesCategoriesAdapter.getSelectors(
  (state: RootState) => state.sellerProfilesCategories);
export default sellerProfilesCategoriesSlice.reducer;
